/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ETrackedItemTypes} from "../../../../../constants/trackedItems";

const FAVORITE_TYPE = ETrackedItemTypes.RADAR_CONFIGURATION
const INNERVTAB_URL_PARAM = 'innervtabs-1'
const FAVORITE_PARAM_ID = INNERVTAB_URL_PARAM
const TRACKED_ITEM_LABEL_PREFIX = "Radar"

export interface RadarPropertiesTableRow{
  propertyName: string
  propertyValue: string
  unit: string
}
export interface RadarPropertiesObject{
  key: string
  label: string
  unit: string
}

export const radarPropsKeyToTitleMap: RadarPropertiesObject[] = [
  
  {
    key: "azimuthFOV",
    label: "Instrumentation Azimuth Limit",
    unit: "deg"
  },
  {
    key: "elevationFOV",
    label: "Instrumentation Elevation Limit",
    unit: "deg"
  },
  {
    key: "maxInstrumentedRange",
    label: "Instrumentation Range Limit",
    unit: "m"
  },
]

export const fovAndBoresightRadarKeyToLabelMap: RadarPropertiesObject[] = [
  {
    key: "azimuth_fov",
    label: "Azimuth FOV",
    unit: "deg"
  },
  {
    key: "elevation_fov",
    label: "Elevation FOV",
    unit: "deg"
  },
  {
    key: "max_range",
    label: "Max Det. Range at Boresight",
    unit: "m"
  }
]

export interface ObjectPropertiesInput{
  key: string
  label: string
  isDropDown?: boolean
  unit: string
}

export interface ObjectPropertyRow{
  objectPropertyName: string
  unit: string
  objectPropertyValue: string
  objectPropertyKey: string
} 

export const objectPropertiesInput: ObjectPropertiesInput[] = [
  {
    key: "objectCategory",
    label: "Object Category",
    isDropDown: true,
    unit: ""
  },
  {
    key: "objectName",
    label: "Object Name",
    isDropDown: true,
    unit: ""
  },
  {
    key: "objectVersion",
    label: "Object Version",
    isDropDown: true,
    unit: ""
  },
  {
    key: "objectProperties",
    label: "Object Variants",
    isDropDown: true,
    unit: ""
  },
  {
    key: "temperature",
    label: "Temperature",
    unit: "°C",
    isDropDown: true
  },
  {
    key: "rcs",
    label: "RCS (dBsm)",
    isDropDown: false,
    unit: "dBsm"
  },
  {
    key: "snr",
    label: "SNR",
    isDropDown: false,
    unit: ""
  },
  {
    key: "attenuation",
    label: "Attenuation (- = loss and + = gain)",
    isDropDown: false,
    unit: "dB"
  },
]
// Column names for the Blueline export
export const COLUMN_NAMES = {
  AZIMUTH_ANGLE: "Azimuth Angle (deg)",
  DISTANCE: "Distance (m)",
}
export const MAP_OBJECT_PROFILE_NAME_TO_KEY: any = {
  'Front Profile': 'frontProfile',
  'Side Profile': 'sideProfile',
  'Rear Profile': 'rearProfile',
}
export const MAP_OBJECT_PROFILE_KEY_TO_PROFILE_NAME: any = Object.fromEntries(
  Object.entries(MAP_OBJECT_PROFILE_NAME_TO_KEY).map(([key, value]) => [value, key])
);

export {
  FAVORITE_TYPE,
  INNERVTAB_URL_PARAM,
  FAVORITE_PARAM_ID,
  TRACKED_ITEM_LABEL_PREFIX
}